import makeStyles from "@mui/styles/makeStyles";

export const useMenuItemStyles = makeStyles((theme) => ({
  root: {
    minHeight: 24,
    marginTop: 8,
    padding: "0 4px",
    borderRadius: 4,
    color: theme.palette.grey[700],
    cursor: "pointer",
    "&:first-child": {
      marginTop: 0,
    },
    "&.Mui-disabled": {
      pointerEvents: "none",
    },
    "&:hover": {
      color: theme.palette.grey[900],
      background: theme.palette.grey[100],
    },
  },
}));
